import { createContext, FC } from "react";

import type { Identity } from "./types";

export const AuthenticationRedirectContext = createContext<FC<object> | null>(
  null
);
export const IdentityContext = createContext<Identity | null>(null);
